import { NextImage } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import FrameSVG from '@public/images/image-apostle-minted-frame.svg'
import ApeironTick from '@src/components/share/apeiron/ApeironTick'

const Container = styled(Box)`
  pointer-events: none;
`

const MintedCardFrame = styled(NextImage)`
  position: absolute;
  top: -11px;
  left: -6px;
  aspect-ratio: 320 / 504;
  width: 109%;
`

const TickContainer = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const Tick = styled(ApeironTick)`
  background-color: #000000aa;
  width: 120px;
  .Custom-Tick {
    filter: brightness(0) saturate(100%) invert(47%) sepia(24%) saturate(5129%)
      hue-rotate(84deg) brightness(114%) contrast(79%); // white to green
    width: 55%;
  }
`

const ApostleSelectedOverlay = () => {
  return (
    <Container>
      <MintedCardFrame src={FrameSVG.src} />
      <TickContainer>
        <Tick />
      </TickContainer>
    </Container>
  )
}

export default ApostleSelectedOverlay
